import styled from 'styled-components';

export const PostsLandingMostRecentSECTION = styled.section`
  padding: 0;
`;

export const PostsLandingEditorsPicksSECTION = styled.section`
  margin-bottom: var(--spacing--L) 0;
  padding: var(--spacing--L) 0;

  .grid {
    row-gap: var(--spacing--L);
  }

  .Cards {
    margin-bottom: 0;
  }

  .Cards--title {
    margin-top: 0;
    margin-bottom: var(--spacing--XS);
  }

  .Card {
    padding-bottom: var(--spacing--XS);
  }
`;

export const PostsLandingCTASECTION = styled.section`
  margin-bottom: var(--spacing--M);

  + .DefaultPrefooter {
    margin-top: calc(var(--spacing--M) + var(--spacing--S));
  }
`

export const PostsLandingFurtherReadingSECTION = styled.section`
  margin-bottom: var(--spacing--L);
  padding: 0;

  .Cards {
    margin-bottom: var(--spacing--L);
  }

  h2 {
    text-align: center;
    margin: 0 0 var(--spacing--M);
  }
`;
